import {Component} from '@angular/core';
/**
 * \@title Input Clearable
 */
export class InputClearableExample {
  value = 'Clear me';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-clearable-example',
  templateUrl: './input-clearable-example.html',
  styleUrls: ['./input-clearable-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputClearableExample_tsickle_Closure_declarations() {
/** @type {?} */
InputClearableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputClearableExample.ctorParameters;
/** @type {?} */
InputClearableExample.prototype.value;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
